import React, { useEffect } from 'react';
import classNames from 'classnames';
import { Webform } from '@uncinc/react-drupal-core';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { addRootClasses, removeRootClasses, setWebformSubmitting } from '../../../store/actions/UI';
import { WebformSelect, WebformActions, WebformDate } from '../../../components';

import './style.scss';

const ParagraphWebformReference = ({ entity, className }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const classes = classNames('Paragraph ParagraphWebformReference', className);
  const webformID = entity.getIn(['field_webform', 0, 'target_id']);

  // Hide shape at bottom of page.
  useEffect(() => {
    dispatch(addRootClasses('hide-shape'));
    return () => dispatch(removeRootClasses('hide-shape'));
  }, [dispatch]);

  return (
    <div className={classes}>
      <Webform
        id={webformID}
        onSubmit={() => dispatch(setWebformSubmitting(true))}
        onSuccessfullSubmit={() => dispatch(setWebformSubmitting(false))}
        onFailedSubmit={() => dispatch(setWebformSubmitting(false))}
        scrollToTopAfterSubmit={false}
        displayRequiredIndicator="optional"
        displayValidationErrorBottom={<div className="FormElement__error">{t('webform.validation_error')}</div>}
        overriddenComponents={{
          select: WebformSelect,
          webform_actions: WebformActions,
          date: WebformDate,
          webform_attachment_twig: () => null, // Hide attachments element
        }}
      />
    </div>
  );
};

export default ParagraphWebformReference;
